import baseAPI from "@/api/base";
import { AxiosResponse } from "axios";

export interface AiPrompts {
  aiPromptGenerateAll: string | null;
  aiPromptReply: string | null;
  aiPromptFollowup: string | null;
  aiPromptRefine: string | null;
  aiPromptCompose: string | null;
  aiPromptCallAssistant: string | null;
  // Sent to the sequence n8n workflows as aiSystemPrompt.
  aiPromptSequence: string | null;
  // Per-ICP override for aiPromptCallAssistant, keyed by ICP id.
  aiPromptCallAssistantByIcp?: Record<string, string> | null;
}

export interface ResolvedAiPrompts {
  aiPromptGenerateAll: { value: string | null; source: "user" | "org" | null };
  aiPromptReply: { value: string | null; source: "user" | "org" | null };
  aiPromptFollowup: { value: string | null; source: "user" | "org" | null };
  aiPromptRefine: { value: string | null; source: "user" | "org" | null };
  aiPromptCompose: { value: string | null; source: "user" | "org" | null };
  aiPromptCallAssistant: { value: string | null; source: "user" | "org" | null };
  aiPromptSequence: { value: string | null; source: "user" | "org" | null };
  aiPromptCallAssistantByIcp?: Record<string, string> | null;
}

class AiPromptsService {
  static getOrgAiPrompts = async (): Promise<
    AxiosResponse<{ status: boolean; data: AiPrompts }>
  > => {
    return baseAPI.get("/organizationSetting/ai-prompts");
  };

  static updateOrgAiPrompts = async (
    data: Partial<AiPrompts>
  ): Promise<AxiosResponse<{ status: boolean; data: AiPrompts; msg: string }>> => {
    return baseAPI.put("/organizationSetting/ai-prompts", data);
  };

  static getUserAiPrompts = async (): Promise<
    AxiosResponse<{ status: boolean; data: AiPrompts }>
  > => {
    return baseAPI.get("/user/ai-prompts");
  };

  static updateUserAiPrompts = async (
    data: Partial<AiPrompts>
  ): Promise<AxiosResponse<{ status: boolean; data: AiPrompts; msg: string }>> => {
    return baseAPI.put("/user/ai-prompts", data);
  };

  static getResolvedAiPrompts = async (): Promise<
    AxiosResponse<{ status: boolean; data: ResolvedAiPrompts }>
  > => {
    return baseAPI.get("/user/ai-prompts/resolved");
  };
}

export default AiPromptsService;
